import {shallowEqual} from 'react-redux';
import {useEqualsMemo} from './useEqualsMemo';

export function useShallowMemo<T extends object>(object: T): T {
    return useEqualsMemo(object, shallowEqual);
}
